import { TableColumnsType } from "antd";
import dayjs from "dayjs";
import { useCallback, useMemo } from "react";
import { NavigateFunction } from "react-router-dom";
import { Audit } from "../../../../types/audits";
import BadgeConstatsCount from "../../BadgeConstatsCount";
import StatusBadges from "../../StatusBadges";
import DropdownOptionsAudit from "../components/DropdownOptionsAudit/DropdownOptionsAudit";

type Options = {
  navigate: NavigateFunction;
  onDelete: (id: number) => void;
};

export default function useTableAudits({ navigate, onDelete }: Options) {
  const columns = useMemo(() => {
    const _columns: TableColumnsType<Audit> = [
      {
        title: "TITRE",
        dataIndex: "title",
        key: "title",
        align: "left",
        width: 250,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "SITE",
        dataIndex: ["site", "name"],
        key: "site",
        align: "center",
        width: 150,
      },
      {
        title: "TYPE D'AUDIT",
        dataIndex: ["audit_type", "name"],
        key: "audit_type",
        align: "center",
        width: 150,
      },
      {
        title: "DATE DE L'AUDIT",
        dataIndex: "dateAudit",
        key: "dateAudit",
        align: "center",
        width: 130,
        render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : ""),
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "DATE cloture",
        dataIndex: "datePerformed",
        key: "datePerformed",
        align: "center",
        width: 130,
        render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : ""),
      },
      {
        title: "STATUT",
        dataIndex: "status",
        key: "status",
        align: "center",
        width: 120,
        render: (value) => <StatusBadges value={value} type="audits" />,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "CONSTATS",
        key: "constatsCount",
        dataIndex: "constatsCount",
        align: "center",
        width: 120,
        render: (_, item) => (
          <BadgeConstatsCount
            constatsCount={item.constatsCount}
            constatsClosedCount={item.constatsClosedCount}
          />
        ),
      },
      {
        title: "",
        key: "options",
        dataIndex: "",
        align: "center",
        width: 10,
        render: (_, item) => (
          <DropdownOptionsAudit
            itemId={item.id}
            onModify={(id) => navigate(`/audits/${id}`)}
            onDelete={onDelete}
          />
        ),
      },
    ];
    return _columns;
  }, [navigate, onDelete]);

  const onRowClick = useCallback(
    (record: Audit) => ({ onClick: () => navigate(`/audits/${record.id}`) }),
    [navigate],
  );

  return { columns, onRowClick };
}
